import clsx from "clsx";

const VARIANT_CLASSES = {
  // Dark mode keeps a saturated (not lightened) fill for primary/danger buttons —
  // white text on the light-mode brand/danger hex already clears contrast, and a
  // lightened fill (e.g. sky-400) would force dark text and a second button
  // recipe. Only ghost/secondary, which show color as text on the page background
  // rather than as a filled control, need the lighter onDark token.
  primary: "bg-brand text-white hover:bg-brand-hover dark:bg-brand-fillOnDark dark:hover:bg-brand-dark disabled:opacity-50",
  secondary:
    "bg-gray-100 text-gray-700 border border-gray-300 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:border-gray-600 dark:hover:bg-gray-600 disabled:opacity-50",
  danger: "bg-danger text-white hover:bg-danger-hover dark:bg-red-700 dark:hover:bg-red-800 disabled:opacity-50",
  ghost: "text-brand hover:text-brand-hover dark:text-brand-onDark dark:hover:text-brand-onDarkHover disabled:opacity-50",
};

const SIZE_CLASSES = {
  sm: "text-xs px-3 py-1.5",
  md: "text-sm px-4 py-2",
};

// Matches DESIGN.md's Buttons spec: rounded-control shape, brand/danger fills,
// secondary as gray outline, opacity-50 for disabled (no separate disabled palette).
export default function Button({
  variant = "primary",
  size = "md",
  loading = false,
  disabled = false,
  className,
  children,
  ...props
}) {
  return (
    <button
      className={clsx(
        "inline-flex items-center justify-center gap-2 rounded-control font-medium transition-colors disabled:cursor-not-allowed",
        VARIANT_CLASSES[variant],
        SIZE_CLASSES[size],
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <svg
          className="h-4 w-4 animate-spin"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      )}
      {children}
    </button>
  );
}
